import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import axios from 'axios'
import {toast} from 'react-toastify'
import {isMobile} from 'react-device-detect'

export function PlaceCategoryGroup() {

  const [items, setItems] = useState<any>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getCategoryFilterGroup()
    return () => {
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getCategoryFilterGroup = () => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API2_URL}am/category/filter/group`)
      .then(({data: {error, result}}) => {
        console.log(error)
        console.log(result)
        if (error !== '') {
        } else {
          setItems(result)
          window.scrollTo(0, 0)
        }
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      })
  }

  const setFilterGroup = (item: any) => {
    console.log(item)
    if (window.confirm(`변경 하시겠습니까?`)) {
      axios
        .put(`${process.env.REACT_APP_API2_URL}am/category/group/filter`, {'id': item.id, 'show': item.show, 'order': item.order})
        .then(({data: {error, result}}) => {
          console.log(error)
          console.log(result)
          if (error !== '') {
            toast.error(error)
          } else {
            alert('변경되었습니다.');
            window.location.reload()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  return <>
    <PageTitle breadcrumbs={[]}>카테고리 필터 그룹 관리</PageTitle>
    <div style={{
      padding: isMobile ? 4 : 20,
      borderRadius: isMobile ? 4 : 20,
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    }}>
      <div className="tab-content w-100" id="myTabContent">
        <div className="table-responsive">
          <table className="table table-sm table-striped table-hover" style={{textAlign: 'left', backgroundColor: 'white'}}>
            <thead className="table-bordered" style={{height: 50, verticalAlign: 'middle', fontSize: 15, fontWeight: 500}}>
            <tr>
              <th scope="col" className="min-w-30px"></th>
              <th scope="col" className="min-w-100px">번호</th>
              <th scope="col" className="min-w-100px">그룹명</th>
              <th scope="col" className="min-w-100px">노출여부</th>
              <th scope="col" className="min-w-100px">순서</th>
              <th scope="col" className="min-w-30px"></th>
            </tr>
            </thead>
            <tbody className="align-middle" style={{verticalAlign: 'middle', fontSize: 15, fontWeight: 400}}>
            {
              loading ?
                <tr style={{height: 98}}>
                  <td colSpan={44}>
                    <div style={{width: '100%', height: 400, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <span className='indicator-progress' style={{display: 'block'}}>Loading...<span className='spinner-border spinner-border-sm align-middle ms-2' /></span>
                    </div>
                  </td>
                </tr>
                :
                items !== null && items.map((item: any, index: number) => {
                  return (
                    <tr key={`${index}`} style={{height: 98}}>
                      <td></td>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>
                        <select
                          className='form-control w-75'
                          name='type'
                          value={item.show}
                          onChange={(e) => {
                            const temps = [...items]
                            temps.splice(temps.indexOf(item), 1, item)
                            item.show = e.target.value
                            setItems(temps)

                            setFilterGroup(item)
                          }}
                        >
                          <option value={0}>미노출</option>
                          <option value={1}>노출</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" className="form-control w-50" placeholder="" value={item.order}
                               onChange={(e) => {
                                 const temps = [...items]
                                 temps.splice(temps.indexOf(item), 1, item)
                                 item.order = e.target.value
                                 setItems(temps)

                                 setFilterGroup(item)
                               }}
                        />
                      </td>
                      <td></td>
                    </tr>
                  )
                })
            }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
}

